.moca-submitted .moca.ng-invalid{border:red 1px solid!important;border-radius:2px}input.upload{border:0px solid red!important;margin:0 0 0 14px!important;width:100%;padding:2px!important}
/*# sourceMappingURL=moca-assessment-add.component-O5UVCF6H.css.map */
